import { useEffect, useState } from "react"

/**
 * Detects if the device is touch-only (no hover capability).
 * Uses the `(hover: none)` media query which is more reliable than screen size
 * for determining actual device input capabilities.
 *
 * - Touch devices (mobile/tablet): returns true
 * - Devices with hover (desktop/laptop): returns false
 *
 * Also responds to changes (e.g., connecting a mouse to a tablet).
 */
const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined" && window.matchMedia) {
      const mediaQuery = window.matchMedia("(hover: none)")
      setIsTouchDevice(mediaQuery.matches)

      const handleChange = (e) => setIsTouchDevice(e.matches)
      mediaQuery.addEventListener("change", handleChange)
      return () => mediaQuery.removeEventListener("change", handleChange)
    }
  }, [])

  return isTouchDevice
}

export default useIsTouchDevice
